module.exports = __webpack_public_path__ + "img/popupbanner-sample.33cceddf.png";